import {
    UNASSIGNED_BOOKINGS_LOADING,
    UNASSIGNED_BOOKINGS_FAILED,
    UNASSIGNED_BOOKINGS_SUCCESS,
  } from "../types"
  
  const initialState = {
    unassignedBookings: [],
    loading: false,
    error: false,
  }
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case UNASSIGNED_BOOKINGS_LOADING:
        return {
          ...state,
          loading: true,
          error: false,
          unassignedBookings: [],
        }
      case UNASSIGNED_BOOKINGS_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          unassignedBookings: [],
        }
      case UNASSIGNED_BOOKINGS_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          unassignedBookings: action.payload,
        }
      default:
        return state
    }
  }
  